import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import CustomDatePicker from './CustomDatePicker';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from './ColorModeIconDropdown';

import Search from './Search';

export default function Header({ searchQuery, onSearchChange }) {
  return (
    <Paper
      variant="outlined"
      sx={(theme) => ({
        display: { xs: 'none', md: 'block' },
        width: '100%',
        maxWidth: { sm: '100%', md: '1700px' },
        borderRadius: 5,
        borderColor: alpha(theme.palette.divider, 0.9),
        background: theme.vars
          ? `linear-gradient(180deg, rgba(${theme.vars.palette.background.paperChannel} / 0.72) 0%, rgba(${theme.vars.palette.background.defaultChannel} / 0.62) 100%)`
          : `linear-gradient(180deg, ${alpha(theme.palette.background.paper, 0.72)} 0%, ${alpha(theme.palette.background.default, 0.62)} 100%)`,
        backdropFilter: 'blur(18px)',
        boxShadow: `0 20px 40px ${alpha(theme.palette.common.black, 0.12)}`,
      })}
    >
      <Stack
        direction="row"
        sx={{
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          gap: 2,
        }}
        spacing={2}
      >
        <Box>
          <NavbarBreadcrumbs />
        </Box>
        <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
          <Search value={searchQuery} onChange={onSearchChange} />
          <CustomDatePicker value={new Date()} readOnly />
          <MenuButton showBadge aria-label="Open notifications">
            <NotificationsRoundedIcon />
          </MenuButton>
          <ColorModeIconDropdown />
        </Stack>
      </Stack>
    </Paper>
  );
}
